/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

// window.Vue = require('vue');

// const app = new Vue({
//   el: '#app',
// });

// sidebar toggle for mobile
const mainWrapper = document.getElementById('mainWrapper');
const mobileNavToggle = document.getElementById('mobileNavToggle');

mobileNavToggle.addEventListener('click', (e) => {
  mobileNavToggle.classList.toggle('sidebar-active');
  mainWrapper.classList.toggle('sidebar-active');
});

// main menu accordian
// https://css-tricks.com/using-css-transitions-auto-dimensions/

const parentItems = document.getElementsByClassName('menu-parent');
const subMenus = document.getElementsByClassName('sub-menu');

function collapseSection(element) {
  let sectionHeight = element.scrollHeight;

  let elementTransition = element.style.transition;
  element.style.transition = '';

  requestAnimationFrame(function() {
    element.style.height = sectionHeight + 'px';
    element.style.transition = elementTransition;

    requestAnimationFrame(function() {
      element.style.height = 0 + 'px';
    });
  });

  element.classList.remove('sub-menu--expanded');
}

function expandSection(element) {
  let sectionHeight = element.scrollHeight;

  element.style.height = sectionHeight + 'px';

  function transitionedHandler() {
    element.removeEventListener('transitionend', transitionedHandler);

    element.style.height = null;
  }

  element.addEventListener('transitionend', (e) => transitionedHandler);

  element.classList.add('sub-menu--expanded');
}

if (parentItems.length) {
  for (let i = 0; i < parentItems.length; i++) {
    const parentItem = parentItems[i];

    // to expand and collapse on click
    parentItem.addEventListener('click', (e) => {
      for (let i = 0; i < parentItems.length; i++) {
        const loopParentItem = parentItems[i];
        const loopSubItem = subMenus[i];

        if (
          e.currentTarget === loopParentItem &&
          !loopParentItem.classList.contains('menu-parent--expanded')
        ) {
          expandSection(loopSubItem);
          loopParentItem.classList.add('menu-parent--expanded');
        } else if (loopParentItem.classList.contains('menu-parent--expanded')) {
          collapseSection(loopSubItem);
          loopParentItem.classList.remove('menu-parent--expanded');
        }
      }
    });
  }
}
